// window._ = require('lodash');

import { createApp } from 'vue'
import mitt from 'mitt';

import MainAppCore from './MainAppCore.vue';

const app = createApp(MainAppCore);
const emitter = mitt();

const Observer = {
	start() {
		document.addEventListener('DOMContentLoaded', () => {
			const elements = document.querySelectorAll('[class*=" intersect-"],[class*=":intersect-"],[class^="intersect-"]');

			elements.forEach(element => {

				let observer = new IntersectionObserver(entries => {

					entries.forEach(entry => {

						if (entry.isIntersecting === false) {
							// element.setAttribute('no-intersect', '');
							return;
						}

						element.removeAttribute('no-intersect');

						element.classList.contains('intersect-once') && observer.unobserve(entry.target); // observer.disconnect()
					});
				});

				observer.observe(element);
			});
		});
	}
};
Observer.start();

app.config.globalProperties.emitter = emitter;

app.mount('#app')


/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

// window.axios = require('axios');
// window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', e => {
	if (e.matches) {
		emitter.emit('theme:set','dark');
	} else {
		emitter.emit('theme:set','light');
	}
});

window.scrollToAnchor = function(anchor) {
	var element_to_scroll_to = document.getElementById(anchor);
	element_to_scroll_to.scrollIntoView();
}


